function updateCart() {
    console.log('cart updated')
      $.ajax({
          url: '/cart',
          dataType: 'HTML',
          method: "GET",
          success: function(htmlData) {
              let html_markup = $(htmlData);
              let to_replace = $('#js-cart').html();
              console.log(to_replace)
              $('#js-cart').html(to_replace);
          }
      });
  }
  
  $('[data-jsredirect]').on("click", function(e) {
    updateCart();
    $(this).css('pointer-events', 'none');
    $(this).attr('disabled', 'disabled');
    $(this).css('opacity', '0.5');
    $(this).css('cursor', 'wait');
      setTimeout(function() {
          console.log("click event")
         $('.js-cart-checkout-button-new').trigger('click');
      }, 2000);
  }); 
  $('[data-desktop-atc-1]').on("click", function(e) {
  
    updateCart();
    $(this).css('pointer-events', 'none');
    $(this).attr('disabled', 'disabled');
    $(this).css('opacity', '0.5');
    $(this).css('cursor', 'wait');
      setTimeout(function() {
          console.log("click event")
         $('.js-cart-checkout-button-new').trigger('click');
      }, 2000);
  }); 
  $('[data-desktop-atc-2]').on("click", function(e) {
    updateCart();
    $(this).css('pointer-events', 'none');
    $(this).attr('disabled', 'disabled');
    $(this).css('opacity', '0.5');
    $(this).css('cursor', 'wait');
      setTimeout(function() {
          console.log("click event")
         $('.js-cart-checkout-button-new').trigger('click');
      }, 2000);
  }); 
  $('.shopify-payment-button__button').on("click", function(e) {
      updateCart();
      $(this).css('pointer-events', 'none');
      $(this).attr('disabled', 'disabled');
      $(this).css('opacity', '0.5');
      $(this).css('cursor', 'wait');
        setTimeout(function() {
            console.log("click event")
           $('.js-cart-checkout-button-new').trigger('click');
        }, 2000);
    }); 
  $('[data-desktop-atc-3]').on("click", function(e) {
    updateCart();
    $(this).css('pointer-events', 'none');
    $(this).attr('disabled', 'disabled');
    $(this).css('opacity', '0.5');
    $(this).css('cursor', 'wait');
      setTimeout(function() {
          console.log("click event")
         $('.js-cart-checkout-button-new').trigger('click');
      }, 2000);
  })